<div>
  <div class="mat-body-2">{{heading}}</div>
  <div class="progress-bar" style="border: 1px solid {{progressColor}}">
    <div class="progress" [style.width.%]="percent" [style.backgroundColor]="progressColor"></div>
  </div>
  <div class="mat-caption">{{caption}}</div>
</div>
